<template>
  <main class="section blog-page">
    <div class="shell">
      <section class="blog-section">
        <header class="page-head">
          <h1>Legacy Projects</h1>
          <p>Jobs from back in the beginning and the projects that built who we are.</p>
        </header>

        <div class="blog-grid">
          <router-link v-for="post in legacyPosts" :key="post.slug" :to="`/blog-posts/${post.slug}`" class="card blog-card">
            <img :src="post.cover" :alt="post.title" />
            <div class="blog-content">
              <p class="meta">{{ post.category }} · {{ post.date }}</p>
              <h2>{{ post.title }}</h2>
              <p>{{ post.excerpt }}</p>
            </div>
          </router-link>
        </div>
      </section>

      <section class="blog-section following-section">
        <header class="page-head">
          <h2 class="section-heading">Everyday Repairs</h2>
          <p>Sometimes it’s the simple things that make the difference.</p>
        </header>

        <div class="blog-grid">
          <router-link v-for="post in everydayPosts" :key="post.slug" :to="`/blog-posts/${post.slug}`" class="card blog-card">
            <img :src="post.cover" :alt="post.title" />
            <div class="blog-content">
              <p class="meta">{{ post.category }} · {{ post.date }}</p>
              <h2>{{ post.title }}</h2>
              <p>{{ post.excerpt }}</p>
            </div>
          </router-link>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import { blogPosts } from '@/data/content';

const everydayRepairSlugs = new Set([
  'repairing-a-7-3-powerstroke-turbo-on-a-99-f350-truck',
  'repairs-on-a-mahindra-4540-tractor-at-centerfire-services',
  'how-to-handle-aging-and-corroded-battery-terminals',
  'quick-and-effective-repair-of-leaky-hydraulic-cylinders-at-centerfire-services',
]);

export default {
  computed: {
    legacyPosts() {
      return blogPosts.filter((post) => !everydayRepairSlugs.has(post.slug));
    },
    everydayPosts() {
      return blogPosts.filter((post) => everydayRepairSlugs.has(post.slug));
    },
  },
};
</script>

<style scoped>
.blog-page {
  padding-top: clamp(10rem, 15vw, 12rem);
}

.following-section {
  margin-top: clamp(5rem, 10vw, 8rem);
}

.section-heading {
  font-size: var(--h1);
  max-width: 20ch;
}

.blog-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.blog-card {
  overflow: hidden;
  display: block;
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.blog-card:hover,
.blog-card:focus-visible {
  transform: translateY(-2px);
  border-color: var(--orange);
}

.blog-card:hover h2,
.blog-card:focus-visible h2 {
  color: var(--orange);
}

.blog-card img {
  width: 100%;
  aspect-ratio: 1.25 / 1;
  object-fit: cover;
}

.blog-content {
  padding: 1rem;
  display: grid;
  gap: 0.62rem;
}

.meta {
  color: var(--accent);
  font-weight: 700;
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.blog-content h2 {
  font-size: var(--h3);
}

.blog-content p {
  color: var(--white);
}

@media (max-width: 980px) {
  .blog-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .blog-grid {
    grid-template-columns: 1fr;
  }
}
</style>
